import graph from "@irati/utils/services/graph"
import PBService, {PBServiceProps} from "@irati/utils/services"
import {AuthProvider, User} from "@irati/types"
import tokens from "@irati/auth/services/tokens"
import googleapisScript from "@irati-web/platform/src/utils/googleapis"
import History from "@irati/utils/history"
import {loginRequest, msalInstance} from "@irati-web/platform/src/utils/microsoftapis/index"

import InternalAuthStream from "../streams/auth"
import {toString as ssoLoginQuery} from "./queries/ssoAdminLogin"
import loginErrorHandler from "./errors/loginErrorHandler"

export interface LoginResponse {
  accessToken: string
  user: User
}

class InternalLogin extends PBService {
  private script: Promise<any>

  constructor(props: PBServiceProps) {
    super(props)
    this.script = googleapisScript.setup()
  }

  ssoLogin(token: string, authProvider: AuthProvider): Promise<void> {
    const variables = {
      token,
      authProvider
    }

    const options = {
      useErrorHandler: false,
      unAuth: true
    }

    return graph({query: ssoLoginQuery, variables, operationName: "ssoAdminLogin"}, options)
      .then(async (data) => {
        const {accessToken, ...rest} = data.ssoAdminLogin
        await tokens.clear()
        await tokens.set({accessToken})
        if (!InternalAuthStream.isInitialised) {
          await InternalAuthStream.start(rest)
        }
      })
      .catch((e) => {
        throw e
      })
  }

  loginGoogle(): Promise<void> {
    const makeRequest = (googleUser: any, resolve: () => any, reject: (e: Error) => any) => {
      this.ssoLogin(googleUser.credential, AuthProvider.Google)
        .then(() => {
          resolve()
        })
        .catch((e) => {
          reject(e)
        })
    }

    return this.script.then(() => {
      return new Promise((resolve, reject) => {
        /* eslint-disable */
        google.accounts.id.initialize({
          client_id: "700487821543-e5u17in68omjfhqb8281dptgooccqpe7.apps.googleusercontent.com",
          auto_select: true,
          callback: (data: any) => makeRequest(data, resolve, reject)
        })
        google.accounts.id.prompt()
        /* eslint-disable */
      })
    })
  }

  loginMsal(): Promise<void> {
    return new Promise((resolve, reject) => {
      msalInstance()
        .ssoSilent(loginRequest)
        .then(({accessToken}) => {
          this.ssoLogin(accessToken, AuthProvider.Microsoft)
            .then(() => resolve())
            .catch((e) => reject(e))
        })
        .catch(() => {
          msalInstance().loginRedirect(loginRequest)
        })
    })
  }

  refresh() {
    const prevLogin = localStorage.getItem("authProvider")
    if (prevLogin === AuthProvider.Google) {
      return this.loginGoogle()
    } else if (prevLogin === AuthProvider.Microsoft) {
      return this.loginMsal()
    }
    return History.push({pathname: "/welcome/login", state: {nextPathname: window.location.pathname}})
  }
}

const internalLoginService = new InternalLogin({errorHandlers: [loginErrorHandler]})

export default internalLoginService
